import { api } from './client';

export interface NuCallWidgetConfig {
  enabled: boolean;
  script_url?: string;
  script_integrity?: string;
  widget_key?: string;
  launcher_position?: 'left' | 'right';
  locale?: 'ar' | 'en';
  dir?: 'rtl' | 'ltr';
  hidden_path_prefixes?: string[];
  identity?: {
    token: string;
    expires_at: number;
    refresh_after: number;
    subject: string;
  };
  tenant?: { id: string; name: string; name_ar?: string };
}

export interface NuCallAdminConfig {
  enabled: boolean;
  widget_key: string;
  identity_secret_set: boolean;
  identity_secret_last4: string;
  identity_secret_set_at: string | null;
  is_configured: boolean;
  visible_roles: string[];
  hidden_path_prefixes: string[];
  launcher_position: 'auto' | 'left' | 'right';
  share_email: boolean;
  share_phone: boolean;
  pii_consent_at: string | null;
  last_verified_at: string | null;
  verification_error: string;
}

export interface NuCallAdminUpdate {
  enabled?: boolean;
  widget_key?: string;
  identity_secret?: string;
  visible_roles?: string[];
  hidden_path_prefixes?: string[];
  launcher_position?: string;
  share_email?: boolean;
  share_phone?: boolean;
  pii_consent?: boolean;
}

/** Boot payload for the signed-in user. Always resolves — the backend answers
 *  200 with {enabled:false} rather than an error, so a NuCall problem never
 *  surfaces in the UI. */
export const getNuCallWidget = (locale: 'ar' | 'en', signal?: AbortSignal) =>
  api
    .get<NuCallWidgetConfig>(`/integrations/nucall/widget/?locale=${locale}`, { signal })
    .then((r) => r.data);

export const getNuCallConfig = () =>
  api.get<{ config: NuCallAdminConfig }>('/integrations/nucall/config/').then((r) => r.data.config);

export const saveNuCallConfig = (body: NuCallAdminUpdate) =>
  api.put<{ config: NuCallAdminConfig }>('/integrations/nucall/config/', body).then((r) => r.data.config);

export const disconnectNuCall = () =>
  api.delete<{ config: NuCallAdminConfig }>('/integrations/nucall/config/').then((r) => r.data.config);

/** Asks NuCall whether *this browser's origin* is allowlisted — the single most
 *  likely misconfiguration, and otherwise invisible. */
export const verifyNuCall = () =>
  api
    .post<{ success: boolean; origin: string; error: string }>('/integrations/nucall/verify/', {
      origin: window.location.origin,
    })
    .then((r) => r.data);
